// [2026-09-27] ADDED — the lucide icons the InCruiter sidebar and top bar draw, copied exactly.
//
// WHY COPIED AND NOT `npm install lucide-react`. The other products' sidebar (the shared
// `@contact_incruiter/fcc` InCruiterSidebar / InCruiterTopBar) draws these from lucide-react. Adding
// that package here would put a dependency into the bundle of BOTH this app and
// proctoring-frontend-admin, which compiles against this package, for eleven icons — the same
// reasoning icons.jsx records for hand-drawing its set. So each icon's geometry is copied byte for
// byte from lucide-react 0.553.0 (the version frontend-incbot pins; dist/esm/icons/<name>.js), and
// rendered with lucide's own default attributes (dist/esm/defaultAttributes.js) and `size` rule
// (Icon.js: width = height = size). Same shapes, same stroke, so the rail is pixel-identical.
//
// lucide-react is ISC-licensed: "Permission to use, copy, modify, and/or distribute this software
// for any purpose with or without fee is hereby granted", notice retained here.
//   lucide-react v0.553.0 — ISC — https://github.com/lucide-icons/lucide
//
// Decorative: aria-hidden, like lucide's own output when no accessible name is given. Every icon
// sits beside a text label or inside a control that carries one (see icons.jsx for the rule).

const BASE = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true',
  focusable: 'false',
}

function lucide(name, nodes) {
  function LucideIcon({ size = 24, strokeWidth = 2, style, className = '' }) {
    return (
      <svg {...BASE} width={size} height={size} strokeWidth={strokeWidth} style={style}
           className={`lucide lucide-${name}${className ? ` ${className}` : ''}`}>
        {nodes.map(([Tag, attrs], i) => <Tag key={i} {...attrs} />)}
      </svg>
    )
  }
  LucideIcon.displayName = name
  return LucideIcon
}

export const Menu = lucide('menu', [
  ['path', { d: 'M4 5h16' }],
  ['path', { d: 'M4 12h16' }],
  ['path', { d: 'M4 19h16' }],
])

export const ChevronsUpDown = lucide('chevrons-up-down', [
  ['path', { d: 'm7 15 5 5 5-5' }],
  ['path', { d: 'm7 9 5-5 5 5' }],
])

// lucide exports this as both CircleUser and UserCircle; the sidebar imports it as UserCircle.
export const UserCircle = lucide('circle-user', [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['circle', { cx: '12', cy: '10', r: '3' }],
  ['path', { d: 'M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662' }],
])

export const CreditCard = lucide('credit-card', [
  ['rect', { width: '20', height: '14', x: '2', y: '5', rx: '2' }],
  ['line', { x1: '2', x2: '22', y1: '10', y2: '10' }],
])

export const ChevronDown = lucide('chevron-down', [
  ['path', { d: 'm6 9 6 6 6-6' }],
])

export const LayoutDashboard = lucide('layout-dashboard', [
  ['rect', { width: '7', height: '9', x: '3', y: '3', rx: '1' }],
  ['rect', { width: '7', height: '5', x: '14', y: '3', rx: '1' }],
  ['rect', { width: '7', height: '9', x: '14', y: '12', rx: '1' }],
  ['rect', { width: '7', height: '5', x: '3', y: '16', rx: '1' }],
])

export const Package = lucide('package', [
  ['path', { d: 'M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z' }],
  ['path', { d: 'M12 22V12' }],
  ['polyline', { points: '3.29 7 12 12 20.71 7' }],
  ['path', { d: 'm7.5 4.27 9 5.15' }],
])

export const Settings = lucide('settings', [
  ['path', { d: 'M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915' }],
  ['circle', { cx: '12', cy: '12', r: '3' }],
])

export const Headphones = lucide('headphones', [
  ['path', { d: 'M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3' }],
])

export const LogOut = lucide('log-out', [
  ['path', { d: 'm16 17 5-5-5-5' }],
  ['path', { d: 'M21 12H9' }],
  ['path', { d: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4' }],
])

// [2026-10-27] ADDED — Shapes (My Subscriptions) and Hexagon (Explore Products), the two icons the
// sidebar redesign (fcc 1.1.0) adds. Geometry from lucide-react 0.553.0 dist/esm/icons/shapes.js and
// hexagon.js, as above.
export const Shapes = lucide('shapes', [
  ['path', { d: 'M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z' }],
  ['rect', { x: '3', y: '14', width: '7', height: '7', rx: '1' }],
  ['circle', { cx: '17.5', cy: '17.5', r: '3.5' }],
])

export const Hexagon = lucide('hexagon', [
  ['path', { d: 'M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z' }],
])

export const Bell = lucide('bell', [
  ['path', { d: 'M10.268 21a2 2 0 0 0 3.464 0' }],
  ['path', { d: 'M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326' }],
])

// [2026-10-29] ADDED — Workflow, the sidebar's Workflows row (INC-2046). Geometry from lucide-react
// 0.553.0 dist/esm/icons/workflow.js, as above.
export const Workflow = lucide('workflow', [
  ['rect', { width: '8', height: '8', x: '3', y: '3', rx: '2' }],
  ['path', { d: 'M7 11v4a2 2 0 0 0 2 2h4' }],
  ['rect', { width: '8', height: '8', x: '13', y: '13', rx: '2' }],
])
